import React from 'react';

export default function Ticker({ t }) {
  const items = [...t.ticker, ...t.ticker];

  return (
    <div className="bg-volt text-ink overflow-hidden py-3">
      <div className="flex w-max animate-marquee">
        {items.map((item, i) => (
          <span
            key={i}
            className="flex items-center gap-6 pr-6 font-display font-bold text-sm uppercase tracking-[0.18em] whitespace-nowrap"
          >
            {item}
            <span className="inline-block w-1.5 h-1.5 bg-ink" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
